import { register, getPrefix } from '../../../Utils'

const Maps = el => {
  const prefix = getPrefix(el)
  const markers = JSON.parse(el.dataset.markers)
  const center = JSON.parse(el.dataset.center)
  const zoomLevel = JSON.parse(el.dataset.zoom)

  let map
  let google = window.google

  const initMap = () => {
    map = new google.maps.Map(el.querySelector(`.${prefix}map-container`), {
      center: { lat: +center.latitude, lng: +center.longitude },
      zoom: +zoomLevel
    })

    if (markers && typeof markers === 'object') {
      markers.forEach(marker => {
        const tooltip = new google.maps.InfoWindow({
          content: `<div class="${prefix}marker-tooltip">${marker.company}</div>`
        })
        const markerIcon = new google.maps.Marker({
          position: { lat: +marker.latitude, lng: +marker.longitude },
          map,
          title: marker.company
        })
        markerIcon.addListener('click', () => {
          tooltip.open(map, markerIcon)
        })
        google.maps.event.addListener(map, 'click', () => {
          tooltip.close()
        })
      })
    }
  }

  initMap()
}

register('Maps', Maps)
